var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isMaster)?_c('btn',{attrs:{"type":"warning","block":""},on:{"click":_vm.clear}},[_c('i',{staticClass:"mdi mdi-filter-remove"}),_vm._v("\n    ELIMINAR FILTROS\n  ")]):_c('placeholder')],1)}
var staticRenderFns = []

export { render, staticRenderFns }